const ckechVerifiedIcon = `
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 8C0 3.58172 3.58172 0 8 0V0C12.4183 0 16 3.58172 16 8V8C16 12.4183 12.4183 16 8 16V16C3.58172 16 0 12.4183 0 8V8Z" fill="#E0F8E3"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M12.7289 4.75762C12.8627 4.88403 12.8688 5.095 12.7424 5.22883L7.07569 11.2288C7.01272 11.2955 6.92506 11.3333 6.83336 11.3333C6.74165 11.3333 6.65399 11.2955 6.59102 11.2288L3.25768 7.69942C3.13128 7.56558 3.13731 7.35461 3.27115 7.22821C3.40499 7.10181 3.61596 7.10783 3.74236 7.24167L6.83335 10.5145L12.2577 4.77109C12.3841 4.63725 12.5951 4.63122 12.7289 4.75762Z" fill="#247133"/>
</svg>
`;

export default ckechVerifiedIcon;
